// Lightweight vanilla slider for gallery variation `pingvin-galerie-slider`
document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll(".pingvin-galerie-slider")
  if (!galleries.length) return

  galleries.forEach(initGallery)

  function initGallery(container) {
    // Find images inside the gallery block
    const imgs = Array.from(container.querySelectorAll("img"))
    if (!imgs.length) return

    // Build slider markup
    const slider = document.createElement("div")
    slider.className = "pingvin-slider"

    const track = document.createElement("div")
    track.className = "pingvin-slider-track"

    imgs.forEach(img => {
      const slide = document.createElement("div")
      slide.className = "pingvin-slide"
      // Move the image node into slide (preserve attributes)
      slide.appendChild(img.cloneNode(true))
      track.appendChild(slide)
    })

    slider.appendChild(track)

    // Controls
    const prev = document.createElement("button")
    prev.className = "pingvin-slider-prev"
    prev.type = "button"
    prev.setAttribute("aria-label", "Previous slide")
    prev.innerHTML = "‹"

    const next = document.createElement("button")
    next.className = "pingvin-slider-next"
    next.type = "button"
    next.setAttribute("aria-label", "Next slide")
    next.innerHTML = "›"

    slider.appendChild(prev)
    slider.appendChild(next)

    // Replace container content
    container.innerHTML = ""
    container.appendChild(slider)

    // Slider logic
    let index = 0
    const slides = track.querySelectorAll(".pingvin-slide")
    const total = slides.length

    function update() {
      const offset = -index * 100
      track.style.transform = `translateX(${offset}%)`
    }

    prev.addEventListener("click", () => {
      index = (index - 1 + total) % total
      update()
    })
    next.addEventListener("click", () => {
      index = (index + 1) % total
      update()
    })

    // keyboard
    slider.addEventListener("keydown", e => {
      if (e.key === "ArrowLeft") prev.click()
      if (e.key === "ArrowRight") next.click()
    })

    // make track transition smooth
    track.style.transition = "transform 400ms ease"

    // optional autoplay
    let autoplayId = null
    const autoplay = container.dataset.autoplay !== undefined
    const autoplayDelay = parseInt(container.dataset.autoplayDelay || "5000", 10)
    if (autoplay) {
      autoplayId = setInterval(() => {
        index = (index + 1) % total
        update()
      }, autoplayDelay)
      // pause on hover
      slider.addEventListener("mouseenter", () => clearInterval(autoplayId))
      slider.addEventListener("mouseleave", () => {
        autoplayId = setInterval(() => {
          index = (index + 1) % total
          update()
        }, autoplayDelay)
      })
    }

    // initial layout
    update()
    // accessibility
    slider.tabIndex = 0

    // Lightbox: open full-size image on click
    slides.forEach(slide => {
      const img = slide.querySelector("img")
      if (!img) return
      img.style.cursor = "zoom-in"
      img.addEventListener("click", function (e) {
        e.preventDefault()
        openLightbox(img.src, img.alt)
      })
    })

    function openLightbox(src, alt) {
      const overlay = document.createElement("div")
      overlay.className = "pingvin-lightbox-overlay"

      const box = document.createElement("div")
      box.className = "pingvin-lightbox-content"

      const image = document.createElement("img")
      image.src = src
      image.alt = alt || ""
      box.appendChild(image)
      overlay.appendChild(box)

      function remove() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay)
        document.removeEventListener("keydown", onKey)
      }

      overlay.addEventListener("click", function (ev) {
        if (ev.target === overlay) remove()
      })

      function onKey(ev) {
        if (ev.key === "Escape") remove()
      }

      document.addEventListener("keydown", onKey)
      document.body.appendChild(overlay)
    }
  }
})
